export enum StorageKeys {
  // SessionStorage keys
  TestFromComplex = 'testFromComplex',
  ComplexTestId = 'complexTestId',
  ComplexRoute = 'complexRoute',
  ComplexId = 'ComplexId',
  ComplexTargetConcept = 'complexTargetConcept',
  MonitoringComplexId = 'monitoringComplexId', // Для мониторинга студентов в Complex Grid
  AdaptiveLearningResume = 'adaptiveLearningResume',
  AdaptiveLearningAlgorithm = 'adaptiveLearningAlgorithm',
  
  // LocalStorage keys
  CurrentUser = 'currentUser',
  CurrentSubject = 'currentSubject',
  ActiveChat = 'activeChat',
  TestsModuleTab = 'testsModule_tab',
  Theme = 'theme',
  SelectedComplex = 'selectedComplex',
  Locale = 'locale',
  Start = 'start',
  Toggle = 'toggle',
  DiplomProjectTab = 'diplomProject_tab',
  CourseProjectTab = 'courseProject_tab',
}

